import React from 'react';
import Link from 'next/link';
import * as S from '../styled';
import * as ST from './styled';
import { sectionData } from './section-data';

const renderList = () => {
    return (
        sectionData.map(({ id, title, text }) => (
            <ST.ListItem key={id}>
                <S.DataTitle isLight>{title}</S.DataTitle>
                <S.DataText isLight>{text}</S.DataText>
            </ST.ListItem>
        ))
    );
};

export const HeadSection = () => {
    return (
        <S.Section bgColor='#000'>
            <S.InnerContainer>
                <ST.HeadTitle>Быстрый интернет от Дом.ру</ST.HeadTitle>
                <ST.HeadText>
                    Играйте с низким пингом — Т-34 попадёт точно в цель. Смотрите серию без зависаний — Шерлок не замрёт на половине разгадки. Не ждите загрузки. Интернета хватит на всё.
                </ST.HeadText>
                <Link href='/internet' passHref>
                    <S.Button type='accent'>Выбрать тариф</S.Button>
                </Link>
            </S.InnerContainer>
            <S.ImgWrap>
                <S.Img src='/static/images/domru-internet/head-internet.jpg' alt=''/>
            </S.ImgWrap>
            <S.InnerContainer>
                <ST.List>
                    {renderList()}
                </ST.List>
            </S.InnerContainer>
        </S.Section>
    );
};
